export default __webpack_public_path__ + "static/media/time.faa5c224.svg";